import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { TextBox, When } from 'UI/components/atoms';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import DecisionDialog from 'UI/components/organisms/DecisionDialog';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { CallVerbiages } from '../CallVerbiages';

import { StyledDivider, useDrawerStyles } from './RoleplayManualDrawer.styled';

const COPIES = strings.ai.generators.roleplay.listPage.manualDrawer;

export const RoleplayManualDrawer = ({
  callType = null,
  leftContent = null,
  onClose,
  open = true,
  subtitle = '',
  title
}) => {
  const classes = useDrawerStyles();
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
  const [presentationText, setPresentationText] = useState('');

  const handleConfirmDrawerClose = () => {
    setIsConfirmationDialogOpen(false);
    onClose && onClose();
  };

  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick') return;
    setIsConfirmationDialogOpen(true);
  };

  const buttonDefinitions = [
    {
      props: {
        onClick: () => setIsConfirmationDialogOpen(true),
        text: strings.shared.ui.close,
        variant: 'outlined'
      },
      GridItemProps: {
        md: 'auto'
      }
    }
  ];

  const CustomDialogActions = ({ defaultButtonsProps, ActionsMapper }) => {
    const { onClose: closeDialog } = defaultButtonsProps;

    return (
      <ActionsMapper
        buttons={[
          {
            variant: 'outlined',
            text: strings.ai.generators.presentationsMaker.warningCloseDialog.actions
              .discardAndExit,
            onClick: handleConfirmDrawerClose
          },
          {
            text: strings.ai.generators.presentationsMaker.warningCloseDialog.actions.cancel,
            onClick: closeDialog
          }
        ]}
      />
    );
  };

  const handleTextChange = (_name, text) => {
    setPresentationText(text);
  };

  const leftContentRendered = leftContent
    ? leftContent({
        callType,
        presentationText
      })
    : null;

  return (
    <FPDrawer
      CardHeaderProps={{
        title: strings.formatString(strings.ai.generators.title, { title }),
        subheader: subtitle
      }}
      FPDrawerProps={{
        open,
        classes: { paper: classes.drawerLarge },
        ModalProps: { disableEscapeKeyDown: true }
      }}
      onClose={handleClose}
      hasPaddingContent={false}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <Grid container className={classes.grid}>
        <Grid item xs={12} sm={3} className={classes.leftColumn}>
          <div className={classes.leftContainer}>{leftContentRendered}</div>
        </Grid>

        <Grid item xs={12} sm={9} className={classes.rightColumn}>
          <div className={classes.rightContainer}>
            <Box display="flex" flexDirection="column" gridGap={8} margin={3}>
              <Typography variant="subtitle1">{COPIES.presentation.title}</Typography>
              <Typography color="textSecondary" variant="body2">
                {COPIES.presentation.subtitle?.[callType] || ''}
              </Typography>

              <TextBox
                fullWidth
                multiline
                noMargin
                onChange={handleTextChange}
                placeholder={COPIES.presentation.placeholder}
                rows={10}
                rowsMax={15}
                size="small"
                value={presentationText}
                variant="outlined"
              />
            </Box>
            <StyledDivider />
            <CallVerbiages callType={callType} />
          </div>
        </Grid>
      </Grid>

      <When condition={isConfirmationDialogOpen}>
        <DecisionDialog
          CustomActions={CustomDialogActions}
          isOpened
          message={strings.ai.generators.presentationsMaker.warningCloseDialog.message}
          onClose={() => setIsConfirmationDialogOpen(false)}
          onConfirm={handleConfirmDrawerClose}
          showSeverityIcon
          title={strings.ai.generators.presentationsMaker.warningCloseDialog.title}
          withButtons="YesNo"
        />
      </When>
    </FPDrawer>
  );
};
